/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type TagProject_item$ref = any;
export type TagProject_item = {
    readonly serviceId: string | null;
    readonly projects: ReadonlyArray<{
        readonly serviceId: string | null;
        readonly name: string | null;
    } | null> | null;
    readonly " $refType": TagProject_item$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "TagProject_item",
        "type": "Item",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "userId",
                "type": "String!"
            }
        ],
        "selections": [
            (v0 /*: any*/),
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "projects",
                "storageKey": null,
                "args": [
                    {
                        "kind": "Variable",
                        "name": "userId",
                        "variableName": "userId"
                    }
                ],
                "concreteType": "Project",
                "plural": true,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "name",
                        "args": null,
                        "storageKey": null
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = 'd055e4fa6a80148dc2d64434cd2a9373';
export default node;
